import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const REMARK_PLUGINS = [remarkGfm];

export const Markdown = ({ children }) => (
  <div className="md-body">
    <ReactMarkdown remarkPlugins={REMARK_PLUGINS}>{children}</ReactMarkdown>
  </div>
);
